import { Link } from "react-router-dom";
import { Phone, Mail, ArrowRight } from "lucide-react";
import { useBookCall } from "@/components/BookCallContext";
import { TESTIDS } from "@/constants/testIds";

const PHONE = "+91 97692 32430";
const EMAIL = "hello@kyrolabs.ai";

export default function Footer() {
    const { openModal } = useBookCall();
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid={TESTIDS.footer.root}
            style={{
                background: "#0e1116",
                color: "#c7ccd6",
                padding: "52px 0 28px",
                marginTop: 20,
            }}
        >
            <div className="wrap">
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "2fr 1fr 1fr",
                        gap: 30,
                    }}
                    className="footer-grid"
                >
                    <div>
                        <div
                            className="font-display"
                            style={{
                                fontWeight: 700,
                                fontSize: "1.15rem",
                                color: "#fff",
                                marginBottom: 10,
                                display: "flex",
                                alignItems: "center",
                                gap: 10,
                            }}
                        >
                            <span
                                style={{
                                    width: 22,
                                    height: 22,
                                    borderRadius: 7,
                                    background: "linear-gradient(135deg,#3b78ff,#0e3bbf)",
                                }}
                            />
                            KyroLabs
                        </div>
                        <p style={{ fontSize: ".88rem", color: "#9aa1ad", maxWidth: 300 }}>
                            We build agents for the job, on an engine we own.
                        </p>
                    </div>

                    <FooterCol title="Company">
                        <Link to="/products" style={footerLink}>Products</Link>
                        <Link to="/practices" style={footerLink}>Practices</Link>
                        <Link to="/industries" style={footerLink}>Industries</Link>
                        <Link to="/use-cases" style={footerLink}>Use Cases</Link>
                        <Link to="/technology" style={footerLink}>Technology</Link>
                        <Link to="/about" style={footerLink}>About Us</Link>
                    </FooterCol>

                    <FooterCol title="Contact us">
                        <a href={`tel:${PHONE.replace(/\s/g, "")}`} style={footerLink}>
                            <Phone size={13} style={{ display: "inline", marginRight: 8 }} />
                            {PHONE}
                        </a>
                        <a href={`mailto:${EMAIL}`} style={footerLink}>
                            <Mail size={13} style={{ display: "inline", marginRight: 8 }} />
                            {EMAIL}
                        </a>
                        <button
                            data-testid={TESTIDS.footer.bookCall}
                            onClick={() => openModal({ source: "footer" })}
                            style={{ ...footerLink, background: "transparent", border: "none", padding: 0, cursor: "pointer" }}
                        >
                            Book a Demo <ArrowRight size={12} style={{ display: "inline" }} />
                        </button>
                    </FooterCol>
                </div>

                <div
                    style={{
                        borderTop: "1px solid #1c2129",
                        marginTop: 32,
                        paddingTop: 20,
                        display: "flex",
                        justifyContent: "space-between",
                        flexWrap: "wrap",
                        gap: 10,
                        fontSize: ".76rem",
                        color: "#7c828e",
                    }}
                >
                    <span>© {year} KyroLabs · Privacy · Terms · Trust & Security</span>
                    <span>A product of KyroLabs AI Pvt Ltd.</span>
                </div>
            </div>
            <style>{`
                @media (max-width: 720px) {
                    .footer-grid { grid-template-columns: 1fr 1fr !important; }
                }
                @media (max-width: 460px) {
                    .footer-grid { grid-template-columns: 1fr !important; }
                }
            `}</style>
        </footer>
    );
}

function FooterCol({ title, children }) {
    return (
        <div>
            <h5
                className="font-mono-label"
                style={{ color: "#7c828e", marginBottom: 14, fontWeight: 500 }}
            >
                {title}
            </h5>
            <div style={{ display: "grid", gap: 9 }}>{children}</div>
        </div>
    );
}

const footerLink = {
    color: "#c7ccd6",
    textDecoration: "none",
    fontSize: ".88rem",
    fontFamily: "inherit",
    textAlign: "left",
    transition: "color .15s",
};
